import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { getRequest, postRequest } from '../../requestUtils';
import ProjectLead from '../ProjectLead';
import ReviewAlert from './ReviewAlert';
import HowCloraWorksForEmployers from '../HowCloraWorksForEmployers';
import ThankYouForReview from '../ThankYouForReview';
import EmployerProjectCard from './EmployerProjectCard';
import ReferralTrigger from '../ReferralTrigger';
import climbingTheLadderImg from '../../../assets/images/climbing-the-ladder.png';
import referralPersonImg from '../../../assets/images/referral-person.jpg';
import { analyticsTrack } from '../../analyticsUtils';
import './EmployerProjectIndexContainer.scss';
var renderEmptyText = function renderEmptyText(status) {
  var statuses = {
    draft: {
      title: 'drafts',
      description: 'A project is in draft when it is still being edited and has not been submitted for review yet.'
    },
    open: {
      title: 'open projects',
      description: 'A project is open after it has been submitted to Clora for review and/or still being actively worked on.'
    },
    closed: {
      title: 'closed projects',
      description: 'A project closes when the engagement with the consultant terminates and/or the need no longer exists.'
    }
  };
  var statusInfo = statuses[status];
  if (statusInfo) {
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", null, "0 ".concat(statusInfo.title)), /*#__PURE__*/React.createElement("div", {
      className: "body-text-2 description"
    }, statusInfo.description));
  }
  return null;
};
var buildStatusHref = function buildStatusHref(projectsPath, status) {
  if (!projectsPath) return '#';
  var separator = projectsPath.includes('?') ? '&' : '?';
  return "".concat(projectsPath).concat(separator, "status=").concat(encodeURIComponent(status));
};
var renderTab = function renderTab(isActive, clickTab, statusText, count, href) {
  var _statusText$split = statusText.split(' '),
    _statusText$split2 = _slicedToArray(_statusText$split, 2),
    firstWord = _statusText$split2[0],
    secondWord = _statusText$split2[1];
  return /*#__PURE__*/React.createElement("a", {
    href: href,
    role: "button",
    tabIndex: 0,
    className: "body-text-2 medium-weight tab-active-".concat(isActive, " d-flex text-nowrap"),
    onClick: function onClick(event) {
      if (clickTab) {
        event.preventDefault();
        clickTab();
      }
    }
  }, firstWord, secondWord && /*#__PURE__*/React.createElement(Fragment, null, "\xA0", /*#__PURE__*/React.createElement("span", {
    className: "d-none d-md-inline"
  }, secondWord)), "\xA0(", count, ")");
};
var renderStep = function renderStep(icon, title, description, showVerticalLine) {
  return /*#__PURE__*/React.createElement("div", {
    className: "step"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "circle-icon-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "g-column g-column--centered"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-".concat(icon)
  }))), showVerticalLine && /*#__PURE__*/React.createElement("div", {
    className: "vertical-dotted-line"
  })), /*#__PURE__*/React.createElement("div", {
    className: "step-description"
  }, /*#__PURE__*/React.createElement("div", {
    className: "body-text-2 medium-weight"
  }, title), description));
};
var EmployerProjectIndexContainer = /*#__PURE__*/function (_Component) {
  function EmployerProjectIndexContainer(props) {
    var _this;
    _classCallCheck(this, EmployerProjectIndexContainer);
    _this = _callSuper(this, EmployerProjectIndexContainer, [props]);
    _this.state = {
      status: props.status || 'open',
      showHowCloraWorks: props.showHowCloraWorks,
      showThankYouForReview: props.reviewed !== null,
      showDemo: false,
      showDemoContainer: true,
      questionableId: null,
      projects: props.projects
    };
    _this.requestDemo = _this.requestDemo.bind(_this);
    _this.closeHowCloraWorks = _this.closeHowCloraWorks.bind(_this);
    _this.closeThankYouForReview = _this.closeThankYouForReview.bind(_this);
    _this.openDemo = _this.openDemo.bind(_this);
    _this.closeDemo = _this.closeDemo.bind(_this);
    _this.hideDemoContainer = _this.hideDemoContainer.bind(_this);
    _this.clickTab = _this.clickTab.bind(_this);
    _this.renderReviewCard = _this.renderReviewCard.bind(_this);
    return _this;
  }
  _inherits(EmployerProjectIndexContainer, _Component);
  return _createClass(EmployerProjectIndexContainer, [{
    key: "requestDemo",
    value: function requestDemo() {
      var _this2 = this;
      var _this$props = this.props,
        requestDemoUrl = _this$props.requestDemoUrl,
        csrfToken = _this$props.csrfToken,
        userId = _this$props.userId,
        questionnaireId = _this$props.questionnaireId;
      postRequest(requestDemoUrl, {
        survey: {
          user_id: userId,
          questionnaire_id: questionnaireId
        }
      }, csrfToken).then(function (response) {
        _this2.setState({
          showDemo: true,
          questionableId: response.data.id
        });
      });
    }
  }, {
    key: "closeHowCloraWorks",
    value: function closeHowCloraWorks() {
      this.setState({
        showHowCloraWorks: false
      });
      analyticsTrack('Closed How Clora Works for Employer modal', {
        location: 'Projects Index View'
      });
    }
  }, {
    key: "closeThankYouForReview",
    value: function closeThankYouForReview() {
      this.setState({
        showThankYouForReview: false
      });
    }
  }, {
    key: "openDemo",
    value: function openDemo() {
      this.requestDemo();
      this.setState({
        showDemo: true,
        showHowCloraWorks: false
      });
    }
  }, {
    key: "closeDemo",
    value: function closeDemo() {
      this.setState({
        showDemo: false
      });
    }
  }, {
    key: "hideDemoContainer",
    value: function hideDemoContainer() {
      this.setState({
        showDemoContainer: false
      });
    }
  }, {
    key: "clickTab",
    value: function clickTab(status) {
      var _this3 = this;
      getRequest('/projects', {
        status: status
      }).then(function (response) {
        analyticsTrack('Clicked a project status tab', {
          status: status,
          location: 'Projects Index View'
        });
        _this3.setState({
          projects: response.data,
          status: status
        });
      });
    }
  }, {
    key: "renderEmptyProjectTab",
    value: function renderEmptyProjectTab(showRequestDemo) {
      var _this4 = this;
      var addProjectPath = this.props.addProjectPath;
      var _this$state = this.state,
        status = _this$state.status,
        showDemoContainer = _this$state.showDemoContainer;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "empty-project-tab box-shadow-1 ".concat(status)
      }, renderEmptyText(status), /*#__PURE__*/React.createElement("div", {
        className: "mt-3"
      }, /*#__PURE__*/React.createElement("a", {
        href: addProjectPath,
        className: "btn btn-primary bigger-button",
        role: "button",
        "data-status": status,
        id: "add-project-empty"
      }, "Add Project"))), showRequestDemo && showDemoContainer && /*#__PURE__*/React.createElement("div", {
        className: "project-lead-container g-row g-row--between"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-column--centered mr-30"
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-rocket ms-2"
      }), "Discover how we can help you find the right talent")), /*#__PURE__*/React.createElement("a", {
        onClick: function onClick() {
          return _this4.openDemo();
        },
        id: "project-lead-request-demo",
        className: "btn btn-primary-dark medium-weight",
        role: "button",
        tabIndex: 0
      }, "Request Demo")));
    }
  }, {
    key: "renderReviewCard",
    value: function renderReviewCard() {
      var reviews = this.props.reviews;
      var numberOfReviews = reviews.length;
      if (numberOfReviews > 0) {
        return /*#__PURE__*/React.createElement(ReviewAlert, {
          reviews: reviews,
          numberOfReviews: numberOfReviews
        });
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;
      var _this$props2 = this.props,
        addProjectPath = _this$props2.addProjectPath,
        projectsPath = _this$props2.projectsPath,
        featuredConsultantsPath = _this$props2.featuredConsultantsPath,
        questionnaireQuestions = _this$props2.questionnaireQuestions,
        questionableType = _this$props2.questionableType,
        projectLeadUrl = _this$props2.projectLeadUrl,
        userFirstName = _this$props2.userFirstName,
        counts = _this$props2.counts,
        csrfToken = _this$props2.csrfToken,
        referralPath = _this$props2.referralPath,
        newReferralPath = _this$props2.newReferralPath,
        authCodeUrl = _this$props2.authCodeUrl,
        shareOnLinkedinUrl = _this$props2.shareOnLinkedinUrl,
        returnFromLinkedIn = _this$props2.returnFromLinkedIn,
        authStatus = _this$props2.authStatus,
        isConsultant = _this$props2.isConsultant,
        location = _this$props2.location,
        referredUserType = _this$props2.referredUserType,
        reviewed = _this$props2.reviewed,
        showProjectEmploymentType = _this$props2.showProjectEmploymentType;
      var _this$state2 = this.state,
        status = _this$state2.status,
        showThankYouForReview = _this$state2.showThankYouForReview,
        projects = _this$state2.projects,
        showDemo = _this$state2.showDemo,
        showHowCloraWorks = _this$state2.showHowCloraWorks,
        questionableId = _this$state2.questionableId;
      var reminderCount = (counts.proposals_need_attention > 0 ? 1 : 0) + (counts.draft > 0 ? 1 : 0) + (counts.open > 0 ? 1 : 0);
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide employer-dashboard"
      }, /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "how-clora-works-for-employers",
        show: showHowCloraWorks,
        onHide: function onHide() {
          return _this5.closeHowCloraWorks();
        }
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(HowCloraWorksForEmployers, {
        userFirstName: userFirstName,
        addProjectPath: addProjectPath,
        featuredConsultantsPath: featuredConsultantsPath,
        showModal: showHowCloraWorks,
        showDemo: this.openDemo,
        handleCloseModal: function handleCloseModal() {
          return _this5.closeHowCloraWorks();
        }
      }))), /*#__PURE__*/React.createElement(Modal, {
        dialogClassName: "thank-you-for-review",
        show: showThankYouForReview,
        onHide: function onHide() {
          return _this5.closeThankYouForReview();
        }
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, null, /*#__PURE__*/React.createElement(ThankYouForReview, {
        userFirstName: reviewed,
        location: "Thank You For Review Modal",
        referredUserType: "employer",
        csrfToken: csrfToken,
        newReferralPath: "/referrals"
      }))), /*#__PURE__*/React.createElement(Modal, {
        show: showDemo,
        onHide: function onHide() {
          return _this5.closeDemo();
        }
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        id: "project-lead",
        className: "style-guide"
      }, questionableId && /*#__PURE__*/React.createElement(ProjectLead, {
        showDemo: showDemo,
        questionnaireQuestions: questionnaireQuestions,
        questionableId: questionableId,
        questionableType: questionableType,
        csrfToken: csrfToken,
        projectLeadUrl: projectLeadUrl,
        afterSubmit: this.hideDemoContainer
      }))), /*#__PURE__*/React.createElement("div", {
        className: "dashboard-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row px-sm-0 px-md-3 container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-7"
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("h1", {
        className: "hero-header mb-2"
      }, "My projects"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2"
      }, "Hi\xA0", userFirstName, ", you can track your project status here to meet your consultants within days.")), /*#__PURE__*/React.createElement("div", {
        className: "project-tabs d-flex flex-column gap-4 flex-md-row"
      }, renderTab(status === 'draft', function () {
        return _this5.clickTab('draft');
      }, 'Drafts', counts.draft, buildStatusHref(projectsPath, 'draft')), renderTab(status === 'open', function () {
        return _this5.clickTab('open');
      }, 'Open Projects', counts.open, buildStatusHref(projectsPath, 'open')), renderTab(status === 'closed', function () {
        return _this5.clickTab('closed');
      }, 'Closed Projects', counts.closed, buildStatusHref(projectsPath, 'closed')))), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-1 d-none d-md-block"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-4 d-none d-md-block text-center"
      }, /*#__PURE__*/React.createElement("img", {
        src: climbingTheLadderImg,
        alt: "",
        width: "186",
        height: "113"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "dashboard-body-background"
      }, /*#__PURE__*/React.createElement("div", {
        className: "dashboard-body container g-row mb-5 px-3 px-lg-0"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-flex-7"
      }, counts[status] > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "project-list"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cards mb-3"
      }, projects.map(function (project) {
        return /*#__PURE__*/React.createElement(EmployerProjectCard, {
          key: "project-".concat(project.resource_id),
          project: project,
          status: status,
          showProjectEmploymentType: showProjectEmploymentType
        });
      })), /*#__PURE__*/React.createElement("div", {
        className: "text-center"
      }, /*#__PURE__*/React.createElement("a", {
        href: addProjectPath,
        className: "btn btn-primary"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-plus me-3"
      }), "Add Project"))) : this.renderEmptyProjectTab(counts.open === 0 && counts.draft === 0 && counts.closed === 0)), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "g-flex-4 "
      }, /*#__PURE__*/React.createElement("div", {
        className: "cards"
      }, this.renderReviewCard()), reminderCount ? /*#__PURE__*/React.createElement("div", {
        className: "mb-4 aside"
      }, /*#__PURE__*/React.createElement("h2", null, "Reminders"), /*#__PURE__*/React.createElement("div", {
        className: "reminders reminders-count-".concat(reminderCount, " body-text-2")
      }, counts.proposals_need_attention > 0 && /*#__PURE__*/React.createElement("div", {
        className: "reminder-group-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "reminder reminder-1 candidates-count"
      }, /*#__PURE__*/React.createElement("div", {
        className: "circle-icon-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-column g-column--centered"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-users"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "count"
      }, counts.proposals_need_attention), /*#__PURE__*/React.createElement("div", {
        className: "text"
      }, "candidate", counts.proposals_need_attention > 1 ? 's' : '', ' ', "to review"))), /*#__PURE__*/React.createElement("div", {
        className: "reminder-group-2"
      }, counts.draft > 0 && /*#__PURE__*/React.createElement("div", {
        className: "reminder reminder-2 draft-count"
      }, /*#__PURE__*/React.createElement("span", {
        className: "count"
      }, counts.draft), ' ', "draft", counts.draft > 1 ? 's' : '', ' ', "to finalize"), counts.open > 0 && /*#__PURE__*/React.createElement("div", {
        className: "reminder reminder-3 open-count"
      }, /*#__PURE__*/React.createElement("span", {
        className: "count"
      }, counts.open), ' ', "open project", counts.open > 1 ? 's' : '')))) : null, /*#__PURE__*/React.createElement("div", {
        className: "aside how-clora-works-for-employer"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "mb-3"
      }, "How Clora Works"), /*#__PURE__*/React.createElement("div", {
        className: "steps"
      }, renderStep('plus-circle', 'Create a project', null, true), renderStep('hourglass-half', 'Submit to Clora', 'Clora reviews your project', true), renderStep('phone', 'Scoping call', 'Our scientific team will set up a 15 min call to qualify your project', true), renderStep('filter', 'Wait for candidates', 'Clora vets the best consultants for your needs', true), renderStep('users', 'Review candidates', 'Review their proposals and interview the ones you like', true), renderStep('handshake', 'Hire the best candidate!', null, false))), /*#__PURE__*/React.createElement("div", {
        className: "aside referral"
      }, /*#__PURE__*/React.createElement("img", {
        src: referralPersonImg,
        alt: "scientist",
        className: "mb-3"
      }), /*#__PURE__*/React.createElement("h2", {
        className: "mb-2"
      }, "Invite hiring managers!"), /*#__PURE__*/React.createElement("div", {
        className: "body-text-2 mb-3"
      }, "Help other hiring managers to find top consultants within days. Earn $500 when your referral hire their first consultant through Clora."), /*#__PURE__*/React.createElement(ReferralTrigger, {
        csrfToken: csrfToken,
        referralPath: referralPath,
        newReferralPath: newReferralPath,
        authCodeUrl: authCodeUrl,
        shareOnLinkedinUrl: shareOnLinkedinUrl,
        returnFromLinkedIn: returnFromLinkedIn,
        authStatus: authStatus,
        isConsultant: isConsultant,
        location: location,
        referredUserType: referredUserType
      }))))));
    }
  }], [{
    key: "scrollToTop",
    value: function scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }]);
}(Component);
EmployerProjectIndexContainer.propTypes = {
  projects: PropTypes.shape({}).isRequired,
  status: PropTypes.string,
  userFirstName: PropTypes.string.isRequired,
  counts: PropTypes.shape({}),
  csrfToken: PropTypes.string.isRequired,
  referralPath: PropTypes.string.isRequired,
  newReferralPath: PropTypes.string.isRequired,
  authCodeUrl: PropTypes.string,
  shareOnLinkedinUrl: PropTypes.string.isRequired,
  returnFromLinkedIn: PropTypes.bool,
  authStatus: PropTypes.number,
  isConsultant: PropTypes.bool,
  location: PropTypes.string.isRequired,
  referredUserType: PropTypes.string.isRequired,
  addProjectPath: PropTypes.string.isRequired,
  projectsPath: PropTypes.string,
  featuredConsultantsPath: PropTypes.string.isRequired,
  questionnaireQuestions: PropTypes.string.isRequired,
  questionableType: PropTypes.string.isRequired,
  projectLeadUrl: PropTypes.string.isRequired,
  requestDemoUrl: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  questionnaireId: PropTypes.string.isRequired,
  showHowCloraWorks: PropTypes.bool,
  reviews: PropTypes.arrayOf(PropTypes.shape({})),
  reviewed: PropTypes.string,
  showProjectEmploymentType: PropTypes.bool
};
EmployerProjectIndexContainer.defaultProps = {
  status: 'open',
  returnFromLinkedIn: false,
  authCodeUrl: null,
  authStatus: null,
  isConsultant: true,
  showHowCloraWorks: false,
  reviewed: null,
  counts: {},
  showProjectEmploymentType: false,
  projectsPath: null
};
export default EmployerProjectIndexContainer;